import Vue from 'vue';

export const BUS_EVENTS = {
  sendTextMessage: 'sendTextMessage', // will be emitted by TypingArea
  sendImageAttachment: 'sendImageAttachment', // emitted by MitraChat/gpt/index.vue
  sendQuickChat: 'sendQuickChat', // will be emitted by QuickChat
  sendFeedbackMessage: 'sendFeedbackMessage', // will be emitted by QuickChat
  showGptTypingInfo: 'showGptTypingInfo', // will show 'CS sedang mengetik...' info
  hideGptTypingInfo: 'hideGptTypingInfo', // will hide 'CS sedang mengetik...' info
  showTransactionOverlay: 'showTransactionOverlay',
  hideTransactionOverlay: 'hideTransactionOverlay',
  handleTransactionNotFound: 'handleTransactionNotFound', // will be emitted by TransactionOverlay
};

const mitraChatGptEventBus = new Vue();

export default mitraChatGptEventBus;
